// https://vuex.vuejs.org/en/getters.html

export default {
  getCart: (state) => state.cart,
  getCartIds: (state) =>
    state.cart && state.cart.map(({ product }) => product.id),
  getCartUniqueIds: (_, { getCartIds }) =>
    getCartIds && [...new Set(getCartIds)],
  getOpen: (state) => state.cartIsOpen,
  showCartFunctional: (state, getters, __, rootGetters) => {
    // Для неавторизованных пользователей всегда показываем корзину
    if (!rootGetters["app/getIsLoggedIn"]) {
      return true;
    }

    // Для авторизованных пользователей показываем корзину если:
    // 1. Включен модуль продуктов (любой view_template)
    // 2. ИЛИ в корзине есть товары с is_pricing_plan: false
    const hasRegularProducts =
      state.cart &&
      Array.isArray(state.cart) &&
      state.cart.some(
        (order) =>
          order && order.product && order.product.is_pricing_plan === false
      );

    return (
      rootGetters["modules/products/isEnabled"] || // Показываем если включен модуль продуктов
      hasRegularProducts
    );
  },
  getTotalValue: (state) => {
    return state.cart
      ? state.cart.reduce((acc, order) => {
          let recurrentPrice = 0;
          const { product, billing_cycle: billingCycle } = order;
          if (billingCycle !== "onetime") {
            recurrentPrice = product[`price_${billingCycle}`];
          }
          return acc + order.qty * product.price_onetime + recurrentPrice;
        }, 0)
      : 0;
  },
};
